import { ReactNode } from "react";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const useStyles = makeStyles(() =>
  createStyles({
    heading1: {
      color: "#fff",
      textShadow: "none",
      fontSize: 30,

      "& p": {
        color: "#fff",
        textShadow: "none",
        fontSize: 30,
        display: "inline",
      },
    },
    subtitle: {
      fontSize: 12,
      color: "#fff",
      textShadow: "none",
      "& small": {
        // color: "#63bc65",
        color: "rgba(245,0,87,.6)",
        fontWeight: "bold",
        fontSize: 10,
      },
    },
    divider: {
      width: "100%",
      height: 1,
      borderColor: "rgba(255, 255, 255, 0.2)",
      borderWidth: 1,
      marginTop: 5,
      marginBottom: 2,
    },
    card: {
      background:
        "background: linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02));",
      // "linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.015))",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(16px)",
      borderRadius: 15,
      padding: "20px 15px",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
      height: "100%",
    },
    iconWrapper: {
      textAlign: "center",
      "& span": {
        textShadow: "none",
        fontSize: 27,
        lineHeight: "32px",
      },
      "& svg": {
        marginBottom: -3,
        color: "#fff",
      },
    },
  }),
);

export enum CardTransactionType {
  WIN = "win",
  LOSS = "loss",
}

interface CardProps {
  icon?: ReactNode;
  primary: ReactNode;
  secondary: ReactNode;
  border?: string;
  type?: CardTransactionType;
}

const getCardBackground = (type: CardTransactionType): string => {
  switch (type) {
    case "win":
      return "linear-gradient(135deg, rgba(63, 227, 126, 0.12), rgba(63, 227, 126, 0.05))";

    case "loss":
      return "linear-gradient(135deg, rgba(255, 92, 92, 0.12), rgba(255, 92, 92, 0.05))";

    default:
      return "linear-gradient(135deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.03))";
  }
};

export default function CardComponent({
  icon,
  primary,
  secondary,
  border,
  type,
}: CardProps) {
  const classes = useStyles();

  return (
    <div
      className={classes.card}
      style={type ? { background: getCardBackground(type) } : {}}
    >
      <Typography
        variant="body1"
        textAlign="center"
        className={classes.iconWrapper}
      >
        {!!icon && icon}
      </Typography>

      <Typography variant="h4" textAlign="center" className={classes.heading1}>
        {primary}
      </Typography>
      <Divider className={classes.divider} />

      <Typography className={classes.subtitle}>{secondary}</Typography>
    </div>
  );
}
